import {
  SET_DASHBOARD_PROFIT_DETAIL,
  SET_DASHBOARD_PROFIT_DETAIL_LOADING,
  SET_DASHBOARD_PROFIT_DETAIL_ERROR,
  SET_BEST_SELLING_PRODUCT,
  SET_BEST_SELLING_PRODUCT_LOADING,
  SET_BEST_SELLING_PRODUCT_ERROR,
  SET_DASHBOARD_OVERVIEW,
  SET_SOLD_PRODUCT_DETAIL,
  SET_SOLD_PRODUCT_DETAIL_LOADING,
  SET_SOLD_PRODUCT_DETAIL_ERROR,
  SET_DASHBOARD_MATERIAL_USAGE,
  SET_DASHBOARD_MATERIAL_USAGE_LOADING,
  SET_DASHBOARD_MATERIAL_USAGE_ERROR,
} from "../../actions/dashboardAction";

var initialState = {
  datas: [],
  loading: false,
  error: null,
  overview: null,
  soldProductDetail: null,
  soldProductDetailLoading: false,
  soldProductDetailError: null,
  materialUsage: null,
  materialUsageLoading: false,
  materialUsageError: null,
  profitDetail: null,
  profitDetailLoading: false,
  profitDetailError: null,
};

const dashboardReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_DASHBOARD_PROFIT_DETAIL:
      return { ...state, profitDetail: action.data, profitDetailError: null };
    case SET_DASHBOARD_PROFIT_DETAIL_LOADING:
      return { ...state, profitDetailLoading: action.status, ...(action.status ? { profitDetail: null, profitDetailError: null } : {}) };
    case SET_DASHBOARD_PROFIT_DETAIL_ERROR:
      return { ...state, profitDetail: null, profitDetailError: action.error };
    case SET_BEST_SELLING_PRODUCT:
      return {
        ...state,

        datas: action.data,
      };
    case SET_DASHBOARD_OVERVIEW:
      return {
        ...state,
        overview: action.data,
        error: null,
      };
    case SET_SOLD_PRODUCT_DETAIL:
      return {
        ...state,
        soldProductDetail: action.data,
        soldProductDetailError: null,
      };
    case SET_SOLD_PRODUCT_DETAIL_LOADING:
      return {
        ...state,
        soldProductDetailLoading: action.status,
      };
    case SET_SOLD_PRODUCT_DETAIL_ERROR:
      return {
        ...state,
        soldProductDetailError: action.error,
      };
    case SET_DASHBOARD_MATERIAL_USAGE:
      return {
        ...state,
        materialUsage: action.data,
        materialUsageError: null,
      };
    case SET_DASHBOARD_MATERIAL_USAGE_LOADING:
      return {
        ...state,
        materialUsageLoading: action.status,
      };
    case SET_DASHBOARD_MATERIAL_USAGE_ERROR:
      return {
        ...state,
        materialUsageError: action.error,
      };

    case SET_BEST_SELLING_PRODUCT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_BEST_SELLING_PRODUCT_LOADING:
      return {
        ...state,
        loading: action.status,
        ...(action.status ? { overview: null, error: null } : {}),
      };
    default:
      return state;
  }
};

export default dashboardReducer;
